import { Component, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'app-splitter',
  templateUrl: './splitter.component.html',
  styleUrls: ['./splitter.component.scss']
})
export class SplitterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
